import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const EnvVars: React.FC = () => {
  const navigate = useNavigate();

  // Get all environment variables that start with VITE_
  const envVars = Object.entries(import.meta.env)
    .filter(([key]) => key.startsWith('VITE_'))
    .sort(([a], [b]) => a.localeCompare(b));

  return (
    <div className="min-h-screen bg-app-background p-6">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-3xl font-bold text-text-primary">Environment Variables</h1>
          <Button variant="secondary" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>

        <div className="bg-game-card rounded-lg p-6">
          <div className="mb-4">
            <p className="text-text-secondary text-sm">
              Showing all environment variables available to the frontend application. Only
              variables prefixed with{' '}
              <code className="bg-app-surface px-1 py-0.5 rounded text-draftkings-primary">
                VITE_
              </code>{' '}
              are exposed.
            </p>
          </div>

          {envVars.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-text-muted">No environment variables found</p>
            </div>
          ) : (
            <div className="space-y-3">
              {envVars.map(([key, value]) => (
                <div
                  key={key}
                  className="bg-app-surface rounded-lg p-4 border border-app-surface hover:border-draftkings-primary/30 transition-colors"
                >
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                    <div className="font-mono text-sm font-semibold text-draftkings-primary min-w-[200px]">
                      {key}
                    </div>
                    <div className="flex-1">
                      <code className="text-text-primary text-sm break-all">{String(value)}</code>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="mt-6 pt-6 border-t border-app-surface">
            <h3 className="text-lg font-semibold text-text-primary mb-3">Additional Info</h3>
            <div className="space-y-2 text-sm text-text-secondary">
              <div className="flex items-start gap-2">
                <span className="font-semibold min-w-[120px]">Mode:</span>
                <code className="text-text-primary">{import.meta.env.MODE}</code>
              </div>
              <div className="flex items-start gap-2">
                <span className="font-semibold min-w-[120px]">Base URL:</span>
                <code className="text-text-primary">{import.meta.env.BASE_URL}</code>
              </div>
              <div className="flex items-start gap-2">
                <span className="font-semibold min-w-[120px]">Production:</span>
                <code className="text-text-primary">{String(import.meta.env.PROD)}</code>
              </div>
              <div className="flex items-start gap-2">
                <span className="font-semibold min-w-[120px]">Development:</span>
                <code className="text-text-primary">{String(import.meta.env.DEV)}</code>
              </div>
              <div className="flex items-start gap-2">
                <span className="font-semibold min-w-[120px]">SSR:</span>
                <code className="text-text-primary">{String(import.meta.env.SSR)}</code>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnvVars;
